export default __webpack_public_path__ + "static/media/nsf-logo.550cb2ce.svg";